"use client";

import React, { useEffect, useState } from "react";
import { useSession } from "next-auth/react";
import Link from "next/link";

const AnnouncementBar = () => {
  const { data: session, status } = useSession();
  const [subscriptionFlow, setSubscriptionFlow] = useState(null);
  const [loading, setLoading] = useState(status === "loading");

  const SHOW_FLOWS = [
    "free_active",
    "free_expired",
    "unlimited_expired",
    "unlimited_payment_failed_expired",
    "institutional_expired",
  ];

  useEffect(() => {
    if (status === "authenticated") {
      fetch(`${process.env.NEXT_PUBLIC_API_URL}/user/get-subscription`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${session.token}`,
        },
      })
        .then((res) => {
          if (!res.ok) throw new Error("Error fetching subscription");
          return res.json();
        })
        .then((data) => setSubscriptionFlow(data.subscription_flow_status))
        .catch(() => setSubscriptionFlow(null))
        .finally(() => setLoading(false));
    } else if (status === "unauthenticated") {
      setLoading(false);
    }
  }, [status, session]);

  // Mientras carga sesión o suscripción, no renderizamos nada
  if (loading) return null;

  // Si está autenticado y su flow NO está en SHOW_FLOWS, ocultamos la barra
  if (status === "authenticated" && !SHOW_FLOWS.includes(subscriptionFlow)) {
    return null;
  }

  // Contenido dinámico según estado y flow
  let message = "¡Activa tu plan gratuito y optimiza tu tiempo!";
  let href = "/registrarse";
  let buttonText = "Empieza gratis";

  if (status === "authenticated" && SHOW_FLOWS.includes(subscriptionFlow)) {
    message = "Plan ilimitado a solo S/ 9.90. Transforma tu forma de enseñar.";
    href = "/cuenta/suscripcion/nueva";
    buttonText = "Suscríbete ahora";
  }

  return (
    <div className="header-top-news bg-image1">
      <div className="wrapper">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="inner">
                <div className="content">
                  <span className="rainbow-badge">Lanzamiento oficial</span>
                  <span className="news-text">{message}</span>
                </div>
                <div className="right-button">
                  <Link className="btn-read-more" href={href}>
                    <span>
                      {buttonText}{" "}
                      <i className="fa-sharp fa-regular fa-arrow-right"></i>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBar;
